import { isObject } from 'lodash/fp';

import { LocalizedText } from '@mews/framework';

export const processError =
    (Component: $TSFixMe) =>
    ({ error, allTouched, touched, ...other }: $TSFixMe) => {
        let localizedError;

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if ((touched || allTouched) && error) {
            localizedError = isObject(error) ? (
                <LocalizedText textKey={(error as $TSFixMe).key} substitutes={(error as $TSFixMe).substitutes} />
            ) : (
                <LocalizedText textKey={error} />
            );
        }

        return <Component {...other} error={localizedError} />;
    };
